import { render, staticRenderFns } from "./kredit.vue?vue&type=template&id=f3b0fd34&scoped=true"
import script from "./kredit.vue?vue&type=script&lang=js"
export * from "./kredit.vue?vue&type=script&lang=js"
import style0 from "./kredit.vue?vue&type=style&index=0&id=f3b0fd34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b0fd34",
  null
  
)

export default component.exports